import React, { useState, useEffect, useMemo } from "react"
import { Link } from "react-router-dom"
import ChooseTimeModal from "../modals/reservation/ChooseTimeModal";

const VisitKindBox = ({ doctor }) => {

    const values = [
        { id: 'appointment', title: 'ویزیت حضوری' },
        { id: 'phone_visit', title: 'ویزیت تلفنی' },
        { id: 'online_visit', title: 'ویزیت متنی' },
    ];

    // ✅ امن‌تر: اگر service_list نبود کرش نکنه
    const initialSelectedValue =
        doctor?.service_list?.length > 0
            ? doctor.service_list[0].type
            : values[0].id;

    const [selectedValue, setSelectedValue] = useState(initialSelectedValue);
    const [filteredVisits, setFilteredVisits] = useState([]);
    const [chooseTime, setChooseTime] = useState()
    const [doctorId, setDoctorId] = useState()
    const [officeId, setOfficeId] = useState()
    const [name, setName] = useState('')
    const [speciality, setSpeciality] = useState('')
    const [address, setAddress] = useState('')
    const [imgUrl, setImgUrl] = useState()

    const [isModalOpen, setIsModalOpen] = useState()

    // ✅ Helper: آیا این نوع ویزیت برای این دکتر وجود دارد؟
    const hasService = (type) => {
        return doctor?.service_list?.some((service) => service.type === type);
    };

    /**
     * ✅ ترتیب مورد نظر شما:
     * 1) حضوری  2) تلفنی  3) متنی
     * اما اگر گزینه‌ای برای دکتر موجود نبود (غیرفعال بود)، به انتهای لیست برود.
     */
    const orderedValues = useMemo(() => {
        const available = [];
        const unavailable = [];

        values.forEach((v) => {
            if (hasService(v.id)) available.push(v);
            else unavailable.push(v);
        });

        return [...available, ...unavailable];
    }, [doctor?.service_list]);

    // ✅ انتخاب اولیه: اولین گزینه‌ی "فعال" طبق ترتیب بالا، و اگر هیچکدام نبود، همان اول orderedValues
    const getInitialSelectedValue = () => {
        const firstAvailable = orderedValues.find((v) => hasService(v.id));
        return (firstAvailable?.id) || (orderedValues[0]?.id) || values[0].id;
    };

    useEffect(() => {
        if (!doctor?.service_list) return;

        const currentStillAvailable = hasService(selectedValue);
        if (!currentStillAvailable) {
            setSelectedValue(getInitialSelectedValue());
        } else {
            setSelectedValue(getInitialSelectedValue());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [doctor?.service_list]);

    useEffect(() => {
        if (!doctor?.service_list) {
            setFilteredVisits([]);
            return;
        }
        const visits = doctor.service_list.filter(s => s.type === selectedValue);
        setFilteredVisits(visits);

    }, [selectedValue, doctor.service_list])

    const formatPrice = (price) => {
        if (typeof price === 'number') {
            return price.toLocaleString('fa-IR');
        }
        return price;
    }

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const reservationHandler = (visit) => {
        console.log('visit NEW:', visit);

        setDoctorId(doctor.id)
        setOfficeId(visit.office[0]?.id)
        // setAppointmentId(visit.id)
        setName(doctor.name)
        setSpeciality(doctor.title)
        setAddress(visit.office[0]?.full_address)
        setImgUrl(`https://bit.medizen.ir/i/${doctor.thumb}`)
        console.log(doctor);
        openModal()

    }

    const renderVisitDetails = (visit) => {
        switch (visit.type) {
            case 'appointment':
                return (
                    <div
                        className="flex flex-col gap-3 mt-2"
                    >
                        <div
                            className="flex flex-col gap-3 bg-[#f3f3f3] py-6 px-5 rounded-[15px]"
                        >
                            <div
                                className="flex flex-col items-center sm:items-start sm:flex-row justify-between font-semibold sm:text-[18px]"
                            >
                                <p
                                    className=" flex gap-1"
                                >
                                    <span className="mb-2">
                                        ویزیت حضوری
                                    </span>
                                    <span
                                        className=""
                                    >
                                        {visit.office[0]?.title}

                                    </span>
                                </p>
                                <p
                                    className="text-purple"
                                >{formatPrice(visit.cost)} تومان</p>
                            </div>
                            <p
                                className=" flex flex-col sm:flex-row gap-1 text-[15px]"
                            >
                                <span
                                    className="font-medium "
                                >اولین زمان آزاد:</span>
                                <span
                                    className="opacity-80"
                                >
                                    {visit.first_free_time ? visit.first_free_time : 'یافت نشد'}
                                </span>
                            </p>

                            {/* ✅ اصلاح مورد شما:
                                - "آدرس مطب:" همیشه یک خطی و نشکنه (whitespace-nowrap)
                                - متن آدرس بیاد ادامه‌اش و خودش نهایتا تا ۲ خط بشه (line-clamp-2)
                                - اگر line-clamp تو پروژه ندارید، می‌تونید حذفش کنید یا جایگزین کنید
                            */}
                            <div className="flex gap-1 text-[15px]">
                                <span className="font-medium whitespace-nowrap">
                                    آدرس مطب:
                                </span>
                                <span className="opacity-80 line-clamp-2">
                                    {visit.office[0]?.full_address}
                                </span>
                            </div>

                            <button
                                onClick={() => reservationHandler(visit)}
                                className="w-full bg-aqua text-white font-medium rounded-[15px] py-4
                                hover:bg-opacity-80 active:scale-90"
                            >
                                دریافت نوبت
                            </button>
                        </div>

                    </div>
                );
            case 'online_visit':
                return (
                    <>
                        <div
                            className="flex flex-col gap-3"
                        >
                            <div className="mb-2 bg-[#f3f3f3] p-5 rounded-[15px] flex flex-col gap-3">
                                <p
                                    className="flex justify-between font-semibold text-[18px]"
                                >
                                    <p
                                        className="flex gap-1"
                                    >
                                    <span className="mb-2">
                                            ویزیت متنی
                                        </span>
                                        <span>
                                            {visit.title}
                                        </span>
                                    </p>
                                    <p
                                        className="text-purple"
                                    >{formatPrice(visit.cost)} تومان</p>
                                </p>
                                {visit.phone && <p
                                    className="flex gap-1"
                                ><span
                                    className="font-medium"
                                >تلفن:</span>
                                    <span
                                        className="opacity-80"
                                    >
                                        {visit.phone.join(', ')}
                                    </span>

                                </p>}
                                <p
                                    className="flex gap-1 text-[15px]"
                                >
                                    <span
                                        className="font-medium"
                                    >اولین زمان آزاد:</span>
                                    <span
                                        className="opacity-80 "
                                    >
                                        {visit.first_free_time ? visit.first_free_time : 'یافت نشد'}
                                    </span>
                                </p>
                                <button
                                    className="w-full bg-aqua text-white font-medium rounded-[15px] py-4
                     hover:bg-opacity-80 active:scale-90"
                                >
                                    دریافت نوبت
                                </button>
                                {/* <p><strong>توضیحات:</strong> {visit.description || visit.response_description}</p> */}
                            </div>


                        </div>
                    </>
                )
            case 'phone_visit':
                return (
                    <>

                        <div
                            className="flex flex-col gap-3"
                        >
                            <div className="mb-2 bg-[#f3f3f3] p-5 rounded-[15px] flex flex-col gap-3">
                                <p
                                    className="flex justify-between font-semibold text-[18px]"
                                >
                                    <p
                                        className="flex gap-1"
                                    >
                                    <span className="mb-2">
                                            ویزیت تلفنی
                                        </span>
                                        <span>
                                            {visit.title}
                                        </span>
                                    </p>
                                    <p
                                        className="text-purple"
                                    >{formatPrice(visit.cost)} تومان</p>
                                </p>
                                {visit.phone && <p
                                    className="flex gap-1"
                                ><span
                                    className="font-medium"
                                >تلفن:</span>
                                    <span
                                        className="opacity-80"
                                    >
                                        {visit.phone.join(', ')}
                                    </span>

                                </p>}
                                {visit.address && <p><span
                                    className="font-medium"
                                >آدرس:</span>
                                    <span
                                        className="opacity-80"
                                    >
                                        {visit.address}
                                    </span>
                                </p>}
                                <p
                                    className="flex gap-1 text-[15px]"
                                >
                                    <span
                                        className="font-medium "
                                    >اولین زمان آزاد:</span>
                                    <span
                                        className="opacity-80 "
                                    >
                                        {visit.first_free_time ? visit.first_free_time : 'یافت نشد'}
                                    </span>
                                </p>
                                <button
                                    className="w-full bg-aqua text-white font-medium rounded-[15px] py-4
                                    hover:bg-opacity-80 active:scale-90"
                                >
                                    دریافت نوبت
                                </button>
                            </div>

                        </div>

                    </>
                );
            default:
                return <p>اطلاعات این نوع ویزیت در دسترس نیست.</p>;
        }
    }

    return (
        <div className="flex p-5 flex-col gap-5 bg-white rounded-[15px] ">
            {isModalOpen ?

                <ChooseTimeModal
                    doctorId={doctorId}
                    officeId={officeId}
                    name={name}
                    speciality={speciality}
                    address={address}
                    imgUrl={imgUrl}
                    isOpen={isModalOpen}
                    onClose={closeModal}
                />
                : ''}
            <p className="font-semibold pb-5 border-b">
                نوع ویزیت:
            </p>

            {/* گزینه‌های غیرفعال در انتها */}
            <ul className="flex flex-col mt-1.5 sm:flex-row gap-1 sm:gap-0 sm:justify-between">
                {orderedValues.map((v) => {
                    const isAvailable = hasService(v.id);
                    const isSelected = selectedValue === v.id;

                    return (
                        <li
                            key={v.id}
                            className={`flex items-center gap-2 ${isAvailable ? "cursor-pointer" : "cursor-not-allowed"
                                }`}
                            onClick={() => {
                                if (!isAvailable) return; // ✅ غیر فعال
                                setSelectedValue(v.id);
                            }}
                            style={!isAvailable ? { opacity: 0.45 } : undefined} // ✅ کم‌رنگ
                        >
                            <span
                                className={`w-4 h-4 border-2 rounded-full flex items-center justify-center ${!isAvailable
                                    ? "border-gray-400"
                                    : isSelected
                                        ? "border-purple"
                                        : "border-gray-400"
                                    }`}
                            >
                                {isSelected && isAvailable && (
                                    <span className="w-2 h-2 
                                    bg-purple rounded-full"></span>
                                )}
                            </span>

                            <span
                                className={`text-sm ${!isAvailable
                                    ? "text-gray-700"
                                    : isSelected
                                        ? "font-medium text-purple"
                                        : "text-gray-700"
                                    }`}
                            >
                                {v.title}
                            </span>
                        </li>
                    );
                })}
            </ul>

            {filteredVisits.length > 0 ? (
                filteredVisits.map((visit) => (
                    <div key={visit.id} className="">
                        {renderVisitDetails(visit)}
                    </div>
                ))
            ) : (
                <div className="text-center py-5 bg-[#f3f3f3] rounded-[15px]">
                    <p>اطلاعاتی برای نوع ویزیت انتخاب شده یافت نشد.</p>
                </div>
            )}
        </div>
    );
};

export default VisitKindBox;
